import {getEventTitle, isDateTbd} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {isMember} from '../../../selectors/current-member-details'
import {getEvent, getFormMessages} from '../../../selectors/event'
import {getEventsMembersPageTitle} from '../../../selectors/events-members-page'
import {showGroupCard} from '../../../selectors/groups'
import {getFormattedRsvpFullNameAndEmail} from '../../../selectors/member-rsvp'
import {getThankYouMessageState} from '../../../selectors/navigation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {ThankYouMessagesOwnProps, ThankYouMessagesRuntimeProps} from './interfaces'
import {ThankYouMessages as Presentation} from './thank-you-messages'

const mapRuntime = (
  {state, actions: {thankYouPageLoaded}}: DetailsPageAppProps,
  {t}: ThankYouMessagesOwnProps,
): ThankYouMessagesRuntimeProps => {
  const event = getEvent(state)
  const {guestEmail, guestName} = getFormattedRsvpFullNameAndEmail(state)

  return {
    guestEmail,
    guestName,
    eventName: getEventTitle(event),
    messages: getFormMessages(event, getThankYouMessageState(state)),
    hideAddToCalendar: isDateTbd(event) || getThankYouMessageState(state) === 'waiting',
    isMember: isMember(state),
    showGroup: showGroupCard(state),
    eventsMembersPageTitle: getEventsMembersPageTitle(state, t),
    thankYouPageLoaded,
  }
}

export const ThankYouMessages = withTranslation()(
  connect<ThankYouMessagesOwnProps, ThankYouMessagesRuntimeProps>(mapRuntime)(Presentation),
)

export * from './interfaces'
